<script setup lang="ts"></script>

<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.3327 6H11.9993V2.66667H3.99935V13.3333H11.9993V10H13.3327V14C13.3327 14.3682 13.0342 14.6667 12.666 14.6667H3.33268C2.96448 14.6667 2.66602 14.3682 2.66602 14V2C2.66602 1.6318 2.96448 1.33333 3.33268 1.33333H12.666C13.0342 1.33333 13.3327 1.6318 13.3327 2V6ZM9.33268 8.66667V10.6667L5.99935 8L9.33268 5.33333V7.33333H14.666V8.66667H9.33268Z"
            fill="currentColor"
        />
    </svg>
</template>
